// Tiny i18n utility with nested keys, interpolation, plural rules, and RTL readiness
const RTL_LANGS = new Set(['ar', 'fa', 'he', 'ur']); // later

const cache = {};
function pluralCategory(lang, count) {
  if (!cache[lang]) {
    try { cache[lang] = new Intl.PluralRules(lang); }
    catch { cache[lang] = new Intl.PluralRules('en'); }
  }
  return cache[lang].select(Number(count));
}
function get(obj, path, fb) {
  return path.split('.').reduce((o, k) => (o && k in o ? o[k] : undefined), obj) ?? fb;
}
function interpolate(str, vars) {
  if (!vars) return str;
  return String(str).replace(/\{(\w+)\}/g, (_, k) => (k in vars ? vars[k] : `{${k}}`));
}

export function createTranslator({ dictionaries, defaultLang = 'en' }) {
  let current = defaultLang;

  function setLang(code) {
    current = dictionaries[code] ? code : defaultLang;
    const dir = RTL_LANGS.has(current) ? 'rtl' : 'ltr';
    document.documentElement.setAttribute('lang', current);
    document.documentElement.setAttribute('dir', dir);
    try { localStorage.setItem('bf_lang', current); } catch {}
  }
  function getLang() { return current; }

  function t(key, vars) {
    const dict = dictionaries[current] || dictionaries[defaultLang] || {};
    if (vars && typeof vars.count !== 'undefined') {
      const cat = pluralCategory(current, vars.count);
      const s = get(dict, `${key}.${cat}`);
      if (s) return interpolate(s, vars);
    }
    const s = get(dict, key);
    if (s) return interpolate(s, vars);

    if (current !== defaultLang) {
      const fb = get(dictionaries[defaultLang] || {}, key);
      if (fb) return interpolate(fb, vars);
    }
    if (process.env.NODE_ENV !== 'production') console.warn(`[i18n] Missing: ${key} (${current})`);
    return key;
  }

  return { t, setLang, getLang };
}
